import { render, staticRenderFns } from "./PostsLoading.vue?vue&type=template&id=7f7fa36e&"
import script from "./PostsLoading.vue?vue&type=script&lang=js&"
export * from "./PostsLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports